import {Component, OnDestroy, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {flatMap, map, tap} from 'rxjs/operators';

@Component({ standalone: false, 
  selector: 'app-rf-paramsets',
  templateUrl: './rf-paramsets.component.html',
})
export class RfParamsetsComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  configPageRfParamSetElements: PaginationInstance = {
    id: 'rfParamSet-elements-list',
    currentPage: 1,
    itemsPerPage: 5,
  }

  public paramSetsRefreshing = false;

  @Input() virtId: string;
  @Input() listRfParamSetElements: any[];
  constructor(private route: ActivatedRoute,
              private router: Router,
              private http: HttpClient,
              private userVerificationService: UserVerificationService,
              private httpService: HttpService) {
    this.isAdmin = this.userVerificationService.isAdmin;
  }

  addRfParamSetPage(name, virtId, title) {
    this.router.navigate(['./add-rfparam-set'], {queryParams: {name, virtId, title}});
  }

  refreshRfParamSetElements() {
    this.RfParamSets(this.virtId);
  }

  RfParamSets(id) {
    this.paramSetsRefreshing = true;
    this.listRfParamSetElements = [];
    var body: any = {"virtId": id};
    var url = ApiEndpoints.GET_RF_PARAM_SET_ELEMENTS;
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listRfParamSetElements = data
          this.paramSetsRefreshing = false;
        }
      );
  }

  ngOnInit() {

  }

  ngOnDestroy() {
  }

}
